import React from 'react';
import ReactDOM from 'react-dom/client';
import { store } from 'store/store';
import { Provider } from 'react-redux';
import { StyledEngineProvider } from '@mui/material/styles';
import App from 'App';
import { eventBus } from 'utils/eventBus';
import { RTCClient } from 'utils/webrtc';

import './i18n';
import { canExposeInternals } from 'utils/development';
import * as z from 'zod';
import { createErrorMap } from 'zod-validation-error';

if (canExposeInternals()) {
  window.RTCClient = RTCClient;
  window.store = store;
}

window.EventBus = eventBus;

z.config({
  customError: createErrorMap(),
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <Provider store={store}>
        <App />
      </Provider>
    </StyledEngineProvider>
  </React.StrictMode>
);
